import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DashboardStats } from '../shared/models/dashboard-stats.model';
import { environment } from '../../environments/environment';
import { ApiResponseModel } from '../shared/models/result.model';
import { MemoryCacheService } from './memoryCache.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardStatsService {
  private http = inject(HttpClient);
  private memoryCacheService = inject(MemoryCacheService);

  private readonly baseUrl = environment.superUserBaseUrl;
  private readonly CACHE_NAMESPACE = 'dashboard-stats-service';
  private static readonly DASHBOARD_STATS_CACHE_MAX_AGE_MS = 1800000; // 30 minutes in ms

  getDashboardStats(): Observable<ApiResponseModel<DashboardStats>> {
    const cacheKey = this.memoryCacheService.generateKey({});
    return this.memoryCacheService.withCache(this.CACHE_NAMESPACE, cacheKey, this.fetchDashboardStatsFromApi(), {
      maxAge: DashboardStatsService.DASHBOARD_STATS_CACHE_MAX_AGE_MS
    });
  }

  private fetchDashboardStatsFromApi(): Observable<ApiResponseModel<DashboardStats>> {
    return this.http.get<ApiResponseModel<DashboardStats>>(`${this.baseUrl}/AdminDashboard`);
  }
}
